import React from "react";
import { Link, useLocation } from "react-router-dom";
import { LifeBuoy } from "lucide-react";

export const HelpButton = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin") || pathname.startsWith("/checkout") || pathname === "/contact") return null;
  return (
    <Link
      to="/contact"
      data-testid="help-fab"
      className="fixed bottom-24 right-4 z-40 flex items-center gap-2 rounded-full bg-ink px-4 py-3 text-sm font-medium text-white shadow-xl transition-transform hover:scale-105 active:scale-95 sm:bottom-5 sm:right-5"
      aria-label="Besoin d'aide ?">
      <LifeBuoy className="h-5 w-5" />
      <span className="hidden sm:inline">Besoin d'aide&nbsp;?</span>
    </Link>
  );
};

export default HelpButton;
